<template>
  <section class="terms-reminders-history">
    <header
      class="terms-reminders-header d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-4"
    >
      <div>
        <p class="eyebrow mb-2">
          Expert management
        </p>
        <h1 class="mb-1">
          Terms Reminders
        </h1>
        <p class="text-muted mb-0">
          Review the history of terms reminder emails sent to experts.
        </p>
      </div>
      <a
        href="/admin/experts"
        class="btn btn-outline-secondary"
      >
        <i class="fa fa-arrow-left me-1" /> Back to Experts
      </a>
    </header>

    <expert-terms-reminders-filter
      v-model="expertName"
      :result-count="pagination.total"
      @search="onSearch"
      @clear="onClear"
    />

    <div
      v-if="loading"
      class="text-center py-5"
    >
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <template v-else>
      <template v-if="experts.length > 0">
        <expert-terms-reminders-table
          :experts="experts"
          @reminder-sent="onReminderSent"
        />

        <expert-terms-reminders-pagination
          :current-page="pagination.current_page"
          :total="pagination.total"
          :per-page="pagination.per_page"
          @page-change="onPageChange"
        />
      </template>

      <div
        v-else
        class="empty-reminders card border-0 text-center shadow-sm"
      >
        <div class="card-body py-5">
          <span class="empty-icon mb-3">
            <i class="fa fa-bell" />
          </span>
          <h3 class="h5 mb-2">
            No terms reminder emails have been sent.
          </h3>
          <p class="text-muted mb-0">
            Try adjusting your search or check again after reminders are sent.
          </p>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import axios from "axios";
import ExpertTermsRemindersFilter from "./ExpertTermsRemindersFilter.vue";
import ExpertTermsRemindersTable from "./ExpertTermsRemindersTable.vue";
import ExpertTermsRemindersPagination from "./ExpertTermsRemindersPagination.vue";

export default {
    name: "ExpertTermsRemindersHistory",
    components: {
        ExpertTermsRemindersFilter,
        ExpertTermsRemindersTable,
        ExpertTermsRemindersPagination,
    },
    data() {
        return {
            expertName: "",
            experts: [],
            loading: true,
            pagination: {
                data: [],
                current_page: 1,
                last_page: 1,
                per_page: 20,
                total: 0,
                from: 0,
                to: 0,
            },
        };
    },
    mounted() {
        this.fetchExperts();
    },
    methods: {
        fetchExperts(page = 1) {
            this.loading = true;

            axios.get("/admin/experts/api/terms-reminders", {
                params: {
                    expert_name: this.expertName,
                    page,
                },
            })
                .then(({ data }) => {
                    this.experts = data.data || [];
                    this.pagination = data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onSearch() {
            this.fetchExperts(1);
        },
        onClear() {
            this.fetchExperts(1);
        },
        onPageChange(page) {
            this.fetchExperts(page);
        },
        onReminderSent() {
            this.fetchExperts(this.pagination.current_page);
        },
    },
};
</script>

<style scoped>
.terms-reminders-history {
    background:
        radial-gradient(circle at 96% 3%, rgba(76, 120, 221, .09), transparent 26rem),
        #f6f8f8;
    border-radius: 18px;
    min-height: calc(100vh - 150px);
    padding: 1.75rem;
}

.terms-reminders-header h1 {
    color: #1F2937;
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: -.035em;
}

.eyebrow {
    color: #4c78dd;
    font-size: .7rem;
    font-weight: 700;
    letter-spacing: .16em;
    text-transform: uppercase;
}

.empty-reminders {
    border-radius: 14px;
}

.empty-icon {
    align-items: center;
    background: #eef2fb;
    border-radius: 50%;
    color: #4c78dd;
    display: inline-flex;
    font-size: 1.4rem;
    height: 62px;
    justify-content: center;
    width: 62px;
}

@media (max-width: 767.98px) {
    .terms-reminders-history {
        padding: 1rem;
    }

    .terms-reminders-header h1 {
        font-size: 1.65rem;
    }
}
</style>
